import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { useTranslation } from '@/hooks/useTranslation';
import { Link } from 'react-router-dom';
import type { StandaloneNavigationItem as StandaloneNavigationItemType } from './types';

interface StandaloneNavigationItemProps {
  item: StandaloneNavigationItemType;
  isActive: (path: string) => boolean;
}

export const StandaloneNavigationItem = ({
  item,
  isActive,
}: StandaloneNavigationItemProps) => {
  const { t, tDynamic } = useTranslation();
  const itemPath = item.path || '#';
  const isItemActive = item.path ? isActive(item.path) : false;
  const translatedName = tDynamic(item.name);
  const ariaLabel = t('navigation.navigateTo', { name: translatedName });

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        isActive={isItemActive}
        tooltip={translatedName}
        aria-label={ariaLabel}
      >
        <Link to={itemPath}>
          <item.icon className='h-4 w-4' />
          <span>{translatedName}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
